import MainPageArrecadacao from '@/screens/arrecadacao/MainPage'

// TELAS GAT
import HomeArrecadacao from '@/screens/arrecadacao/gat/Home'
import CadastroColetivo from '@/screens/arrecadacao/gat/components/cadastroColetivo/CadastroColetivo'
import PecaTecnica from '@/screens/arrecadacao/gat/components/PecaTecnicaArcGis'
import RetificacaoCadastro from '@/screens/arrecadacao/gat/components/retificacaoCadastro/RetificacaoCadastro'
import GatAguardandoValidacao from '@/screens/arrecadacao/gat/GatAguardandoValidacao'

// TELAS CPAT
import EmissaoOficio from '@/screens/arrecadacao/cpat/components/oficio/EmissaoOficio'
import Oficio from '@/screens/arrecadacao/cpat/Oficio'
import HomeCpat from '@/screens/arrecadacao/cpat/Home'
import EmAnaliseCpat from '@/screens/arrecadacao/cpat/EmAnalise'
import AssinaturasCpat from '@/screens/arrecadacao/cpat/Assinaturas'
import ValidacaoCpat from '@/screens/arrecadacao/cpat/Validacao'
import ListagemOficios from '@/screens/arrecadacao/cpat/Oficios'
import Minuta from '@/screens/arrecadacao/cpat/Minuta'
import EmissaoMinuta from '@/screens/arrecadacao/cpat/components/matricula/EmissaoMinuta'
import InformacoesSolicitadas from '@/components/CaixaInformacoesListagem'
import ResponderInformacao from '@/screens/analise/ResponderInformacoes'
import Visualizar from '@/screens/arrecadacao/cpat/Visualizar'
import ResponderMensagem from '@/screens/arrecadacao/cpat/ResponderMensagem'
import EnvioCartorio from '@/screens/arrecadacao/cpat/components/matricula/EnvioCartorio'

// TELAS CAF
import AnaliseProcesso from '@/screens/arrecadacao/components/AnaliseProcesso'
import CafListagem from '@/screens/arrecadacao/caf/CafListagem'

import PERFIL from '@/constants/perfil'

// TELAS GERAIS
import HomeRelatorios from '@/screens/arrecadacao/relatorios/Home'

const setRouteGroup = group => {
  return { routeGroup: group }
}

const perfisGat = [
  PERFIL.ARRECADACAO.GERENTE_GAT.codigo,
  PERFIL.ARRECADACAO.ANALISTA_GAT.codigo,
  PERFIL.ARRECADACAO.GERENTE_ARRECADACAO.codigo
]

const perfisCof = [
  PERFIL.ARRECADACAO.GERENTE_COF.codigo
]

const perfisCaf = [PERFIL.ARRECADACAO.COORDENADOR_CAF_ARRECADACAO.codigo]

const perfisCpat = [PERFIL.ARRECADACAO.PRESIDENTE_CPAT.codigo, PERFIL.ARRECADACAO.ANALISTA_CPAT.codigo]

const perfilRelatorio = [PERFIL.ARRECADACAO.RELATORIOS_ARRECADACAO.codigo]

const arrecadacao = [
  {
    path: '/arrecadacao/cof',
    component: MainPageArrecadacao,
    name: 'arrecadacao/cof',
    redirect: { name: 'cof/home' },
    children: [
      /* conflito de rota com o `cof/home` do financeiro.js
      {
        path: 'home',
        name: 'cof/home',
        component: HomeArrecadacao,
        meta: {
          perfis: perfisCof,
          ...setRouteGroup('COF_EM_ANALISE')
        }
      }, */
      {
        path: 'aguardandoValidacao',
        name: 'cof/aguardandoValidacao',
        component: GatAguardandoValidacao,
        meta: {
          perfis: perfisCof,
          ...setRouteGroup('COF_AGUARDANDO_VALIDACAO')
        }
      },
      {
        path: 'validacaoCadastro',
        name: 'cof/validacaoCadastro',
        component: AnaliseProcesso,
        meta: {
          perfis: perfisCof,
          ...setRouteGroup('COF_AGUARDANDO_VALIDACAO')
        },
        props: route => ({
          routeListagemName: 'cof/aguardandoValidacao',
          ...route.params
        })
      },
      {
        path: 'informacoesSolicitadas',
        name: 'cof/arrecadacao/informacoesSolicitadas',
        component: InformacoesSolicitadas,
        meta: {
          perfis: perfisCof,
          ...setRouteGroup('COF_INFORMACOES_SOLICITADAS')
        }
      },
      {
        path: 'retificacaoCadastro',
        name: 'cof/retificacaoCadastro',
        component: RetificacaoCadastro,
        redirect: 'retificacaoCadastro/pecaTecnica',
        meta: {
          perfis: perfisCof,
          ...setRouteGroup('COF_RETIFICACAO_CADASTRO')
        },
        children: [
          {
            path: 'pecaTecnica',
            name: 'retificacaoCadastro/pecaTecnica',
            component: PecaTecnica,
            meta: {
              ...setRouteGroup('COF_RETIFICACAO_CADASTRO'),
              perfis: perfisCof
            }
          },
          {
            path: '*',
            redirect: { name: 'retificacaoCadastro/pecaTecnica' }
          }
        ]
      },
      {
        path: 'informacoes/:idSolicitacao',
        name: 'cof/informacoes',
        component: ResponderInformacao,
        props: true,
        meta: {
          perfis: perfisCof,
          ...setRouteGroup('COF_INFORMACOES_SOLICITADAS')
        }
      },
      {
        path: 'cadastroColetivo',
        name: 'cof/cadastroColetivo',
        redirect: 'cadastroColetivo/pecaTecnica',
        component: CadastroColetivo,
        meta: {
          ...setRouteGroup('COF_EM_ANALISE'),
          perfis: perfisCof
        },

        children: [
          {
            path: 'pecaTecnica',
            name: 'cadastroColetivo/pecaTecnica',
            component: PecaTecnica,
            meta: {
              ...setRouteGroup('COF_EM_ANALISE'),
              perfis: perfisCof
            }
          },
          {
            path: '*',
            redirect: { name: 'cadastroColetivo/pecaTecnica' }
          }
        ]
      }
    ]
  },
  {
    path: '/arrecadacao/gat',
    component: MainPageArrecadacao,
    name: 'arrecadacao/gat',
    redirect: { name: 'gat/home' },
    children: [
      {
        path: 'home',
        name: 'gat/home',
        component: HomeArrecadacao,
        meta: {
          perfis: perfisGat,
          ...setRouteGroup('GAT_EM_ANALISE')
        }
      },
      {
        path: 'aguardandoValidacao',
        name: 'gat/aguardandoValidacao',
        component: GatAguardandoValidacao,
        meta: {
          perfis: perfisGat,
          ...setRouteGroup('GAT_AGUARDANDO_VALIDACAO')
        }
      },
      {
        path: 'validacaoCadastro',
        name: 'gat/validacaoCadastro',
        component: AnaliseProcesso,
        meta: {
          perfis: perfisGat,
          ...setRouteGroup('GAT_AGUARDANDO_VALIDACAO')
        },
        props: route => ({
          routeListagemName: 'gat/aguardandoValidacao',
          ...route.params
        })
      },
      {
        path: 'informacoesSolicitadas',
        name: 'gat/informacoesSolicitadas',
        component: InformacoesSolicitadas,
        meta: {
          perfis: perfisGat,
          ...setRouteGroup('GAT_INFORMACOES_SOLICITADAS')
        }
      },
      {
        path: 'retificacaoCadastro',
        name: 'gat/retificacaoCadastro',
        component: RetificacaoCadastro,
        redirect: 'retificacaoCadastro/pecaTecnica',
        meta: {
          perfis: perfisGat,
          ...setRouteGroup('GAT_RETIFICACAO_CADASTRO')
        },
        children: [
          {
            path: 'pecaTecnica',
            name: 'retificacaoCadastro/pecaTecnica',
            component: PecaTecnica,
            meta: {
              ...setRouteGroup('GAT_RETIFICACAO_CADASTRO'),
              perfis: perfisGat
            }
          },
          {
            path: '*',
            redirect: { name: 'retificacaoCadastro/pecaTecnica' }
          }
        ]
      },
      {
        path: 'informacoes/:idSolicitacao',
        name: 'gat/informacoes',
        component: ResponderInformacao,
        props: true,
        meta: {
          perfis: perfisGat,
          ...setRouteGroup('GAT_INFORMACOES_SOLICITADAS')
        }
      },
      {
        path: 'cadastroColetivo',
        name: 'gat/cadastroColetivo',
        redirect: 'cadastroColetivo/pecaTecnica',
        component: CadastroColetivo,
        meta: {
          ...setRouteGroup('GAT_EM_ANALISE'),
          perfis: perfisGat
        },

        children: [
          {
            path: 'pecaTecnica',
            name: 'cadastroColetivo/pecaTecnica',
            component: PecaTecnica,
            meta: {
              ...setRouteGroup('GAT_EM_ANALISE'),
              perfis: perfisGat
            }
          },
          {
            path: '*',
            redirect: { name: 'cadastroColetivo/pecaTecnica' }
          }
        ]
      }
    ]
  },
  {
    path: '/arrecadacao/relatorios',
    component: MainPageArrecadacao,
    name: 'arrecadacao/relatorios',
    redirect: { name: 'relatorios-arrecadacao/home' },
    children: [
      {
        path: 'home',
        name: 'relatorios-arrecadacao/home',
        component: HomeRelatorios,
        meta: {
          ...setRouteGroup('ARRECADACAO_RELATORIOS'),
          perfis: perfilRelatorio
        }
      }
    ]
  },
  {
    path: '/arrecadacao/caf',
    component: MainPageArrecadacao,
    name: 'arrecadacao/caf',
    redirect: { name: 'caf/home' },
    children: [
      {
        path: 'home',
        name: 'caf/home',
        component: CafListagem,
        meta: {
          ...setRouteGroup('CAF_CAIXA_DE_ENTRADA'),
          perfis: perfisCaf
        }
      },
      {
        path: 'analiseProcesso',
        name: 'caf/analiseProcesso',
        component: AnaliseProcesso,
        meta: {
          ...setRouteGroup('CAF_CAIXA_DE_ENTRADA'),
          perfis: perfisCaf
        }
      }
    ]
  },
  {
    path: '/arrecadacao/cpat',
    component: MainPageArrecadacao,
    name: 'arrecadacao/cpat',
    redirect: { name: 'cpat/home' },
    children: [
      {
        path: 'validacaoCadastro',
        name: 'cpat/validacaoCadastro',
        component: AnaliseProcesso,
        meta: {
          perfis: perfisCpat,
          ...setRouteGroup('CPAT_AGUARDANDO_VALIDACAO')
        },
        props: { routeListagemName: 'cpat/home' }
      },
      {
        path: 'home',
        name: 'cpat/home',
        component: HomeCpat,
        meta: {
          ...setRouteGroup('CPAT_CAIXA_DE_ENTRADA'),
          perfis: perfisCpat
        }
      },
      {
        path: 'analise',
        name: 'cpat/analise',
        component: EmAnaliseCpat,
        meta: {
          ...setRouteGroup('CPAT_CAIXA_EM_ANALISE'),
          perfis: perfisCpat
        }
      },
      {
        path: 'assinaturas',
        name: 'cpat/assinaturas',
        component: AssinaturasCpat,
        meta: {
          ...setRouteGroup('CPAT_CAIXA_ASSINATURAS'),
          perfis: [PERFIL.ARRECADACAO.PRESIDENTE_CPAT.codigo]
        }
      },
      {
        path: 'validacao',
        name: 'cpat/validacao',
        component: ValidacaoCpat,
        meta: {
          ...setRouteGroup('CPAT_CAIXA_VALIDACAO'),
          perfis: [PERFIL.ARRECADACAO.PRESIDENTE_CPAT.codigo]
        }
      },
      {
        path: 'oficios',
        name: 'cpat/oficios',
        component: ListagemOficios,
        meta: {
          ...setRouteGroup('CPAT_CAIXA_DE_ENTRADA'),
          perfis: perfisCpat
        }
      },
      {
        path: 'oficios/validacaoCadastro',
        name: 'oficios/validacaoCadastro',
        component: AnaliseProcesso,
        meta: {
          perfis: perfisCpat,
          ...setRouteGroup('CPAT_AGUARDANDO_VALIDACAO')
        },
        props: {
          routeListagemName: 'cpat/oficios',
          hasProcesso: true,
          routeFinalizar: 'cpat/home'
        }
      },
      {
        path: 'conversa',
        name: 'cartorio/conversa',
        component: Visualizar,
        props: true,
        meta: {
          ...setRouteGroup('CPAT_CAIXA_DE_ENTRADA'),
          perfis: perfisCpat
        }
      },
      {
        name: 'responder',
        path: 'responder-mensagem',
        props: true,
        meta: {
          ...setRouteGroup('CPAT_CAIXA_DE_ENTRADA'),
          perfis: perfisCpat
        },
        component: ResponderMensagem
      },
      {
        path: 'oficio',
        name: 'cpat/oficio',
        component: Oficio,
        redirect: 'oficio/emissao',
        meta: {
          ...setRouteGroup('CPAT_CAIXA_DE_ENTRADA'),
          perfis: perfisCpat
        },
        children: [
          {
            path: 'emissao',
            name: 'oficio/emissao',
            component: EmissaoOficio,
            meta: {
              ...setRouteGroup('CPAT_CAIXA_DE_ENTRADA'),
              perfis: perfisCpat
            }
          },
          {
            path: 'analise',
            name: 'oficio/analise',
            component: AnaliseProcesso,
            props: {
              isVisualizar: true,
              routeListagemName: 'cpat/oficios',
              hasProcesso: true
            },
            meta: {
              ...setRouteGroup('CPAT_CAIXA_DE_ENTRADA'),
              perfis: perfisCpat
            }
          },
          {
            path: '*',
            redirect: { name: 'oficio/emissao' }
          }
        ]
      },
      {
        path: 'minuta',
        name: 'cpat/minuta',
        component: Minuta,
        redirect: 'minuta/emissao',
        meta: {
          ...setRouteGroup('CPAT_CAIXA_DE_ENTRADA'),
          perfis: perfisCpat
        },
        children: [
          {
            path: 'emissao',
            name: 'minuta/emissao',
            component: EmissaoMinuta,
            meta: {
              ...setRouteGroup('CPAT_CAIXA_DE_ENTRADA'),
              perfis: perfisCpat
            }
          },
          {
            path: 'analise',
            name: 'minuta/analise',
            component: AnaliseProcesso,
            props: {
              routeListagemName: 'cpat/minuta',
              routeFinalizar: 'cpat/home',
              isVisualizar: true,
              hasProcesso: true
            },
            meta: {
              ...setRouteGroup('CPAT_CAIXA_DE_ENTRADA'),
              perfis: perfisCpat
            }
          },
          {
            path: '*',
            redirect: { name: 'minuta/emissao' }
          }
        ]
      },
      {
        path: 'matricula',
        name: 'cpat/matricula',
        component: Minuta,
        redirect: 'matricula/envioMatricula',
        meta: {
          ...setRouteGroup('CPAT_CAIXA_DE_ENTRADA'),
          perfis: perfisCpat
        },
        children: [
          {
            path: 'envioMatricula',
            name: 'matricula/envioMatricula',
            component: EnvioCartorio,
            meta: {
              ...setRouteGroup('CPAT_CAIXA_DE_ENTRADA'),
              perfis: perfisCpat
            }
          },

          {
            path: 'analiseMatricula',
            name: 'matricula/analise',
            component: AnaliseProcesso,
            props: {
              routeListagemName: 'cpat/matricula',
              routeFinalizar: 'cpat/oficios',
              isVisualizar: true,
              hasProcesso: true
            },
            meta: {
              ...setRouteGroup('CPAT_CAIXA_DE_ENTRADA'),
              perfis: perfisCpat
            }
          },
          {
            path: '*',
            redirect: { name: 'matricula/envioMatricula' }
          }
        ]
      }
    ]
  },
  {
    path: '*',
    redirect: '/arrecadacao/'
  }
]

export default arrecadacao



// WEBPACK FOOTER //
// ./src/router/arrecadacao.js